import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { ColoracaoModel } from "./coloracao.model";
import { ColoracaoService } from './coloracao.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";


@Component({
  selector: 'app-coloracao-form',
  templateUrl: './coloracao-form.component.html'
})
export class ColoracaoFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  coloracao: ColoracaoModel = new ColoracaoModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private coloracaoService: ColoracaoService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_coloracao'];

      if (!this.pageIsUpd) {
        this.title = 'Visualizar Coloração';
      } else {
        this.title = id ? 'Editar Coloração' : 'Cadastrar Nova Coloração';
      }

      if (!id) {
        return;
      }

      this.coloracaoService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = 'Editar Coloração: ' + json.Payload[0].nome_pt;
            } else {
              this.title = 'Visualizar Coloração: ' + json.Payload[0].nome_pt;
            }

            this.coloracao = json.Payload[0];
            this.form.patchValue(this.coloracao);

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.coloracaoService.editar(values, values.id);
    } else {
      result = this.coloracaoService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'coloracao']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if (json.Message && json.Message.ErrorInput) {
          for (let i in json.Message.ErrorInput) {
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-coloracao/coloracao-form.component.ts